<template>
  <div class="w-view-shell">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页:开始学习</el-breadcrumb-item>
      <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="maxbox">
      <div class="food">
          {{info.question_detail.qst_name}}
<!--          食品安全管理培训正式考核成绩-->
      </div>
      <img src="@/assets/defen.png" alt="" />
      <el-button @click="$router.push('/simulativeTset')">确定</el-button>
      <div class="grade">{{info.correct_rate}}</div>
      <div class="get">得分</div>
      <div class="congratulation">恭喜你，通过考核！</div>
      <div v-show="show" class="congratulation">很遗憾，您未通过考核！</div>
      <div class="faled">
        <div class="one">
          <img src="@/assets/pitch.png" alt="" />
          <span>{{info.correct_qst}}题</span>
        </div>
        <div class="two handler" @click.stop="go_errno()">
          <img src="@/assets/cuowu.png" alt="" />
          <span class="">{{info.wrong_qst}}题</span>
        </div>
      </div>
    </div>
    <div class="minbox">
      <div class="worn-out">
        <div class="one">答题用时</div>
        <div class="two">{{info.use_time}}</div>
      </div>
      <div class="worn-out">
        <div class="one">正确率</div>
        <div class="two">{{info.correct_rate}}%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fulfillTset",
  data() {
    return {
      title: '模拟练习',
      show: false,
      info: {
        question_detail:{
          qst_name: ''
        }
      }
    };
  },
  mounted () {
    this.info = JSON.parse(this.$route.query.info)
  },
  methods:{
    go_errno(){
      this.$router.push('/personal?code=2&tab_code=2')
    }
  }
};
</script>

<style lang="less" scoped>
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: #000;
  cursor: text;
}
.el-breadcrumb {
  margin-top: 30px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.maxbox {
  position: relative;
  width: 1201px;
  height: 580px;
  border: 1px solid #ccc;
  margin: 30px 0;
  .food {
    min-width: 336px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    margin: 20px 0 0 20px;
  }
  .el-button {
    position: absolute;
    right: 35px;
    top: 20px;
    width: 120px;
    height: 42px;
    border: 1px solid #d8261c;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #d8261c;
  }
  img {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    width: 274px;
    height: 274px;
  }
  .grade {
    position: relative;
    text-align: center;
    font-size: 70px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 230px;
  }
  .get {
    position: relative;
    top: -70px;
    text-align: center;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
  .congratulation {
    height: 1px;
    text-align: center;
    height: 30px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    line-height: 150px;
  }
  .faled {
    display: flex;
    div {
      margin-left: 60px;
      margin-top: 100px;
      text-align: center;
      flex: 1;
    }
    .one {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #000000;
      img {
        position: absolute;
        bottom: 90px;
        left: 250px;
        width: 57px;
        height: 57px;
      }
    }
    .two {
      margin-left: 90px;
      width: 67px;
      height: 28px;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #000000;
      line-height: 50px;
      img {
        position: absolute;
        bottom: 85px;
        left: 870px;
        width: 57px;
        height: 57px;
      }
    }
  }
}
.minbox {
  display: flex;
  margin: 18px 0;
  width: 1201px;
  height: 220px;
  border: 1px solid #ccc;
  div {
    text-align: center;
    flex: 1;
  }
  .worn-out {
    .one {
      height: 25px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 180px;
    }
    .two {
      height: 33px;
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 260px;
    }
  }
}
</style>
